import { useState, useEffect } from 'react';

import styles from './InputRange.module.css';

export interface Payload { target: { value: number } };

interface Props {
  label: string;
  placeholder?: string;
  name?: string;
  disabled?: boolean;
  value: string | number;
  onChange: (e: Payload) => void;
  className?: string;
  ref?: React.RefObject<HTMLInputElement>;
  step: number;
  min: number;
  max: number;
  minLabel?: string;
  maxLabel?: string;
  suffixValue?: string;
};

export function InputRange({
  label, placeholder, name,
  disabled,
  value, onChange,
  className, ref,
  step, min, max,
  minLabel, maxLabel, suffixValue,
}: Props) {
  const [tmpValue, setTmpValue] = useState(value);
  const [isFocus, setIsFocus] = useState(false);

  useEffect(() => {
    if (typeof value === 'string') {
      setTmpValue(parseFloat(value.replaceAll(' ', '')));
    } else {
      setTmpValue(value);
    }
  }, [value]);

  const getContainerClass = () => {
    if (disabled) {
      return `${styles.mainDiv} ${styles.disabled} ${className}`;
    }
    return `${styles.mainDiv} ${styles.container} ${className}`;
  };

  const handleNewValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = 0;
    if (e.target.value) {
      newValue = parseFloat(e.target.value.replaceAll(' ', ''));
    } if (newValue < min) {
      newValue = min;
    } else if (newValue > max) {
      newValue = max;
    }
    if (!Number.isNaN(newValue)) {
      onChange({ target: { value: newValue } });
      setIsFocus(false);
    }
  };

  return (
    <div className={getContainerClass()}>
      <div className={styles.rowAlign}>
        {(label && label !== '')
          && (
            <span
              className={styles.label}
            >
              {label}
            </span>
          )}

        <div className={styles.boxValue}>
          {
            isFocus ? (
              <input
                className={styles.inputBoxValue}
                type="number"
                value={tmpValue}
                onFocus={() => setIsFocus(true)}
                onChange={(e) => setTmpValue(e.target.value)}
                onBlur={handleNewValue}
                min={min}
                max={max}
              />
            ) : (
              <input
                className={styles.inputBoxValue}
                type="text"
                value={value}
                readOnly
                onFocus={() => setIsFocus(true)}
              />
            )
          }
          {(suffixValue && suffixValue !== '')
            && (
              <span className={styles.suffixValue}>
                {suffixValue}
              </span>
            )}
        </div>
      </div>
      <div className={styles.divInputRange}>
        <input
          className={`${styles.inputRange} ${styles.slider}`}
          ref={ref}
          type="range"
          placeholder={placeholder}
          value={tmpValue}
          onChange={handleNewValue}
          name={(name) || undefined}
          aria-label={name}
          readOnly={disabled}
          min={min}
          max={max}
          step={step}
        />
      </div>
      <div>
        {(minLabel && minLabel !== '')
          && (
            <span
              className={styles.minLabel}
            >
              {minLabel}
            </span>
          )}
        {(maxLabel && maxLabel !== '')
          && (
            <span
              className={styles.maxLabel}
            >
              {maxLabel}
            </span>
          )}
      </div>
    </div>
  );
}
